import type { FrontendOnlyPieces } from '../../hooks/useSettings/WebsiteSettings';
import { Icon } from '@iconify/react';
import dumpTruck from '@iconify-icons/mdi/dump-truck';
import type { $TSFixMe } from '@calefy-inc/utilityTypes';

const tileIcons = (businessName: string) => {
  switch (businessName) {
    case 'quarrying_sand_gravel_digging':
      return <Icon icon={dumpTruck} width={'35px'} />;

    default:
      return <Icon icon={dumpTruck} width={'35px'} />;
  }
};

const businessFilter = (business: $TSFixMe) => {
  const allowedBusinessNames = ['quarrying_sand_gravel_digging'];
  if (
    process.env.NODE_ENV !== 'production' ||
    window.location.origin === 'https://staging-calefy.fuseinsurance.ca'
  ) {
    allowedBusinessNames.push('testing_business');
  }
  return allowedBusinessNames.includes(business.internalName);
};

// RockChain Insurance — frontend-only pieces; all data fields live on the backend
export const frontendPieces: FrontendOnlyPieces = {
  slug: 'rockchaininsurance',
  businessFilter,
  tileIcons,
};
